export const taskLink: angular.IDirectiveFactory = () => ({
  scope: {
    task: '=',
  },
  template:
    '<a href="javascript:void(0)" ui-sref="tasks.unitpopup({id: task.task_unit_id})" ng-if="task.task_type===\'1\'">{{\'general.unit\' | translate}} {{task.task_unit_id}}</a>\n' +
    '<a href="javascript:void(0)" ui-sref="tasks.leadpopup({id: task.lead_id})" ng-if="task.task_type===\'2\'">{{task.lead_name ? (task.lead_name | upperFirstChar) : (\'unit.popup.noname\' | translate) }}</a>\n' +
    '<a href="javascript:void(0)" ui-sref="tasks.unitpopup({id: task.task_unit_id})" ng-if="task.task_type===\'3\'">{{task.lead_name ? (task.lead_name | upperFirstChar) : (\'unit.popup.noname\' | translate) }} &#8250; {{task.task_unit_id}}</a>',
});
